import { LogsInitProvider } from './LogsInitComponentesContext/LogsInitComponentesContext'
import { UserProvider } from './UserContext/UserContex'
import { WebSocketProvider } from './WebSocket/WebSocketContext'
import { ThemeAppProvider } from './ThemeContext/ThemeContext'
import { RequestOneProvider } from "./RequestOneContext/RequestOneContext"
import { CondominiosProvider } from './CondominiosContext/CondominiosContext'
import { LoadingPageProvider } from './LoadingPage/LoadingPageContext'
import { EventosProvider } from './EventosContext/EventosContext'
import { TimersProvider } from './Timers/TimersContext'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { ConexaoServerProvider } from './ConexaoServerContext/ConexaoServerContext'
import { LogadoProvider } from './LogadoContext/LogadoContext'
import { ChangeComponentProvider } from './ChangeComponentContext/ChangeComponentContext'
import { OrdemServicoProvider } from './OrdemServicoContext/OrdemServicoContext'
import { RondaProvider } from './RondaContext/RondaContext'
import { AtalhosProvider } from './AtalhosContext/AtalhosContext'

const Providers = ({ children }) => {
    return (
        <DndProvider backend={HTML5Backend}>
            <LogsInitProvider>
                <ThemeAppProvider >
                    <LoadingPageProvider>
                        <ConexaoServerProvider>
                            <RequestOneProvider>
                                <LogadoProvider>
                                    <TimersProvider>
                                        <WebSocketProvider>
                                            <ChangeComponentProvider>
                                                <UserProvider>
                                                    <CondominiosProvider>
                                                        <EventosProvider>
                                                            <OrdemServicoProvider>
                                                                <RondaProvider>
                                                                    <AtalhosProvider>
                                                                        {children}
                                                                    </AtalhosProvider>
                                                                </RondaProvider>
                                                            </OrdemServicoProvider>
                                                        </EventosProvider>
                                                    </CondominiosProvider>
                                                </UserProvider>
                                            </ChangeComponentProvider>
                                        </WebSocketProvider>
                                    </TimersProvider>
                                </LogadoProvider>
                            </RequestOneProvider>
                        </ConexaoServerProvider>
                    </LoadingPageProvider>
                </ThemeAppProvider>
            </LogsInitProvider>
        </DndProvider>
    )
}

export default Providers
